import { makeStyles, Grid } from "@material-ui/core";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  TYPE_INSTANCE4,
} from "App/constants";
import React, { useState } from "react";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
} from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import {
  defaultToastError,
  convertToValidPrice,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
// import { getPoListById, urlCreateBarang, urlUpdateBarang } from "../../helpers";

export const RESET_STATE_PO_BARANG = {
  id: "",
  // po_id: "",
  namabarang: "",
  barang_id: "",
  satuan_id: null,
  namasatuan: "Pilih Satuan",
  qty: 1,
  harga: "0",
  harga2: "0",
  disc: "",
  statUpdate: false,
};

export const STYLE_WMS_PO = makeStyles({
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN",
    align: "left",
  },
  {
    id: "qjb",
    disablePadding: false,
    label: "QJB",
    align: "left",
  },
  {
    id: "hargabeli",
    disablePadding: false,
    label: "HARGA BELI",
    align: "left",
  },
];

export const ModalBarang = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewDataPoList,
  setListPO,
  listPO,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const satuan = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterSatuanLGS.get,
    TYPE_INSTANCE4
  );

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formBarang.qjb <= 0 || formBarang.qty <= 0 || isNull(formBarang.qty)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Banyak barang tidak boleh kosong");
    } else {
      if (isNull(formBarang.harga2) || formBarang.harga2 <= 0) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError("Harga barang tidak boleh kosong");
      }else{
        if (!isNull(formBarang.satuan_id)) {
          try {
            const barang = listPO;
            const checkBarang = barang.filter(
              (e) => e.barang_id === formBarang.barang_id
            );
            if (checkBarang.length === 0) {
              const barang = listPO;
              barang.push({
                id: null,
                namabarang: formBarang?.namabarang,
                namasatuan: formBarang?.namasatuan,
                satuan_id: formBarang?.satuan_id,
                barang_id: formBarang?.barang_id,
                qty: formBarang.qty,
                harga: convertToValidPrice(formBarang.harga2),
                disc: formBarang.disc,
                remark: "",
                set_disc:
                  (formBarang.disc / 100) *
                  (convertToValidPrice(formBarang.harga2) * formBarang.qty),
              });
              setListPO(barang);
            } else {
              const barang = listPO;
              const checkBarang = barang.filter(
                (e) => e.barang_id !== formBarang.barang_id
              );
              checkBarang.push({
                id: formBarang?.id,
                namabarang: formBarang?.namabarang,
                namasatuan: formBarang?.namasatuan,
                satuan_id: formBarang?.satuan_id,
                barang_id: formBarang?.barang_id,
                qty: formBarang.qty,
                harga: convertToValidPrice(formBarang.harga2),
                disc: formBarang.disc,
                remark: "",
                set_disc:
                  (formBarang.disc / 100) *
                  (convertToValidPrice(formBarang.harga2) * formBarang.qty),
              });
              setListPO(checkBarang);
            }
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            setShowModal(false);
          } catch (error) {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(error?.response?.data?.message);
          }
        }else{
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          defaultToastError("Satuan beli tidak boleh kosong");
        }
      }
    }
  };

  // const succesCreateOrUpdate = async (label) => {
  //   defaultToastSuccess(`Berhasil ${label} Barang`);
  //   const res = await getPoListById(formData.idpo);
  //   setListPO(res.data);

  // };

  return (
    <Modal title={formBarang.statUpdate ? `Ubah Barang` : `Tambah Barang`} show={setShowModal} width='40%'>
      {
        <form action='POST' onSubmit={(e) => handleSubmit(e)}>
          <p className='mt-1 mb-1'>{formBarang.namabarang}</p>
          <Grid container spacing={1}>
            <InputTextMaster
              type='hidden'
              name='barang_id'
              id='barang_id'
              readOnly={true}
              value={formBarang.barang_id}
            />
            <Grid item sm={4}>
              <InputOptionMaster
                name='satuan_id'
                label='SATUAN'
                id='satuan_id'
                withSearch={true}
                data={satuan}
                value={formBarang.satuan_id}
                labelValue={formBarang.namasatuan}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormBarang({
                      ...formBarang,
                      satuan_id: null,
                      namasatuan: "Pilih Satuan",
                    });
                  } else {
                    setFormBarang({
                      ...formBarang,
                      satuan_id: e.value,
                      namasatuan: e.label,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item sm={2}>
              <InputTextMaster
                name='qty'
                label='BANYAK'
                id='qty'
                value={formBarang.qty}
                onChange={handleChange("qty")}
                placeholder='Banyak'
              />
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name='harga'
                label='HARGA'
                id='harga'
                placeholder='0'
                value={formBarang.harga2}
                onInput={(e) => {
                  let val = e.target.value;
                  setFormBarang({
                    ...formBarang,
                    harga2: formatRupiah(val),
                  });
                }}
                withButtonLeft={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderLeft: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderRight: "0",
                    background: "#fff",
                    padding: "0 0 0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "6px 0 0 6px",
                    fontSize: "10px",
                  }}
                >
                  Rp.
                </button>
              </InputTextMaster>
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name='disc'
                label='DISC %'
                id='disc'
                value={formBarang.disc}
                onChange={handleChange("disc")}
                placeholder='0'
                withButton={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderRight: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderLeft: "0",
                    background: "#fff",
                    padding: "0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "0 6px 6px 0",
                  }}
                >
                  %
                </button>
              </InputTextMaster>
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            justifyContent='flex-end'
            alignItems='center'>
            <MasterButton
              className={"mt-1"}
              type='submit'
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.disabled}
              size='md'
            />
          </Grid>
        </form>
      }
    </Modal>
  );
};
